module.exports = __webpack_public_path__ + "img/_logo-solar.e5328d2f.png";